import cubejs from '@cubejs-client/core';
import Button from 'app/components/general/Button';
import HeaderThin from 'app/components/layout/HeaderThin';
import React from 'react';
import { Card } from 'reactstrap';
import { convertToUtc } from 'app/utils/parsers';
import timezones from 'app/utils/static/timezones';
import moment from 'moment';
import InputGroupBlock from 'app/components/general/InputGroupBlock';
import timePeriods from 'app/utils/static/timePeriods';
import { getJwtToken } from 'app/ducks/authentication/selectors';

import { ICubeJsGraphProps } from './graphs/base';
import AverageForfeitFeeCard from './graphs/forfeits/AverageForfeitFeeCard';
import ForfeitPaymentVolumeCard from './graphs/forfeits/ForfeitPaymentVolumeCard';
import ForfeitsCard from './graphs/forfeits/ForfeitsCard';
import MoneySavedUsingTeammo from './graphs/forfeits/MoneySavedUsingTeammoCard';
import TimeSavedUsingTeammoCard from './graphs/forfeits/TimeSavedUsingTeammoCard';
import AverageMatchFee from './graphs/matches/AverageMatchFee';
import MatchPaymentByDay from './graphs/matches/MatchPaymentByDay';
import MatchesPaidGraph from './graphs/overview/MatchesPaidGraph';
import PaymentMethodGraph from './graphs/overview/PaymentMethodGraph';
import PaymentVolumeCard from './graphs/overview/PaymentVolumeCard';
import TeammoPaymentsGraph from './graphs/overview/TeammoPaymentsGraph';
import ConnectedTeamsGraph from './graphs/teams/ConnectedTeamsCard';
import TeammoTeamMembers from './graphs/teams/TeammoTeamMembersCard';

const PaddedSection = ({ children, ...props }) => (
  <div
    className={`padded-section ${props.className}`}
  >
    {children}
  </div>
);


interface IDashboardSimpleProps {
  actions: any;
  organisations: any;
  appReady: boolean;
  cubejsApi: any;
}
interface IDashboardSimpleState {
  timePeriod: any;
  timezone: string;
  errors: any;
  competitionId: string;
  changed: boolean;
}

const OverviewGraphs: React.FunctionComponent<ICubeJsGraphProps> = (queryProps) => (
  <>
    <div className="row">
      <div className="col">
        <h3 className="no-margin-bottom">Overview</h3>
      </div>
    </div>
    <div className="row">
      <div className="col">
        <div className="divider full only-top-margin" />
      </div>
    </div>
    <div className="row">
      <div className="col col-12 col-md-4 with-border-right">
        <PaddedSection>
          <PaymentVolumeCard {...queryProps} />
        </PaddedSection>
      </div>
      <div className="col col-12 col-md-4 with-border-right">
        <PaddedSection>
          <MatchesPaidGraph {...queryProps} />
        </PaddedSection>
      </div>
      <div className="col col-12 col-md-4">
        <PaddedSection className="less-padding">
          <PaymentMethodGraph {...queryProps} />
        </PaddedSection>
      </div>
    </div>
    <div className="row">
      <div className="col">
        <div className="divider full only-bottom-margin" />
      </div>
    </div>
    <div className="row">
      <div className="col">
        <h3>Payment Volume ($)</h3>
      </div>
    </div>
    <div className="row">
      <div className="col">
        <PaddedSection>
          <TeammoPaymentsGraph {...queryProps} />
        </PaddedSection>
      </div>
    </div>
    <div className="row">
      <div className="col">
        <div className="divider full only-bottom-margin" />
      </div>
    </div>
  </>
);

const TeamsGraphs: React.FunctionComponent<ICubeJsGraphProps> = (queryProps) => (
  <>
    <div className="row with-margin-top">
      <div className="col">
        <h3 className="no-margin-bottom">Teams</h3>
      </div>
    </div>
    <div className="row">
      <div className="col">
        <div className="divider full only-top-margin" />
      </div>
    </div>
    <div className="row">
      <div className="col col-12 col-md-6 with-border-right">
        <PaddedSection>
          <ConnectedTeamsGraph {...queryProps} />
        </PaddedSection>
      </div>
      <div className="col col-12 col-md-6">

        <PaddedSection>
          <TeammoTeamMembers {...queryProps} />
        </PaddedSection>
      </div>
    </div>
    <div className="row">
      <div className="col">
        <div className="divider full only-bottom-margin" />
      </div>
    </div>
  </>
);


const MatchesGraphs: React.FunctionComponent<ICubeJsGraphProps> = (queryProps) => (
  <>

    <h3 className="no-margin-bottom">Matches</h3>
    <div className="row">
      <div className="col col-12 col-md-4">
        <PaddedSection>
          <AverageMatchFee {...queryProps} />
        </PaddedSection>
      </div>
      <div className="col col-12 col-md-8">

        <PaddedSection>
          <span>Average time of payment graph</span>
          {/* <AverageTimeOfPaymentGraph {...queryProps} /> */}
        </PaddedSection>
      </div>

    </div>

    <div className="row">
      <div className="col-lg">
        <PaddedSection>
          <MatchPaymentByDay {...queryProps} />
        </PaddedSection>
      </div>
    </div>

  </>
);


const ForfeitsGraphs: React.FunctionComponent<ICubeJsGraphProps> = (queryProps) => (
  <>
    <div className="row with-margin-top">
      <div className="col">
        <h3 className="no-margin-bottom">Forfeits</h3>
      </div>
    </div>
    <div className="row">
      <div className="col">
        <div className="divider full only-top-margin" />
      </div>
    </div>
    <div className="row">
      <div className="col col-12 col-md-4 with-border-right">
        <PaddedSection>
          <ForfeitsCard {...queryProps} />
        </PaddedSection>
      </div>
      <div className="col col-12 col-md-4 with-border-right">
        <PaddedSection>
          <ForfeitPaymentVolumeCard {...queryProps} />
        </PaddedSection>
      </div>
      <div className="col col-12 col-md-4">
        <PaddedSection>
          <AverageForfeitFeeCard {...queryProps} />
        </PaddedSection>
      </div>
    </div>
    <div className="row">
      <div className="col">
        <div className="divider full only-bottom-margin" />
      </div>
    </div>

    {/* <div className="row">
      <div className="col col-6">
        <PaddedSection>
          <span>Forfeits by day of match</span>
        </PaddedSection>
      </div>
      <div className="col col-6">
        <PaddedSection>
          <span>Forfeits by match time slot</span>
        </PaddedSection>
      </div>
    </div>

    <div className="row">
      <div className="col-4">
        <PaddedSection>
          <TimeSavedUsingTeammoCard {...queryProps} />

        </PaddedSection>
      </div>
      <div className="col-8">

        <PaddedSection>
          <span>Average time of forfeit submission prior to match</span>
        </PaddedSection>
      </div>

    </div>

    <div className="row">
      <div className="col-4">
        <PaddedSection>
          <MoneySavedUsingTeammo {...queryProps} />
        </PaddedSection>
      </div>
      <div className="col-4">

        <PaddedSection>
          <span>Forfeit reasons</span>
        </PaddedSection>
      </div>

      <div className="col-4">

        <PaddedSection>
          <span>Teams with most forfeits</span>
        </PaddedSection>
      </div>

    </div> */}

  </>
);

export default class DashboardSimple extends React.Component<IDashboardSimpleProps, IDashboardSimpleState> {
  static defaultProps: IDashboardSimpleProps = {
    actions: undefined,
    organisations: undefined,
    appReady: false,
  };

  state: IDashboardSimpleState = {
    dateRange: undefined,
    timePeriod: timePeriods[8],
    competitionId: undefined,
    // timezone: _.find(timezones, (t) => t.id === this.props.organisations?.currentOrganisation?.timezone) || undefined,
    changed: false,
    errors: {},
  };

  handleChangeTimePeriod = (e) => {
    this.setState({ timePeriod: e });
  }

  render(): React.ReactNode {
    const cubejsApi = cubejs(
      (async () => getJwtToken()),
      { apiUrl: CUBEJS_URL },
    );
    // const graphs = [OverviewGraphs];
    // const graphs = [OverviewGraphs, TeamsGraphs, MatchesGraphs, ForfeitsGraphs];

    // const startOn = convertToUtc(moment(this.state.dateRange[0]).format());
    // const endOn = convertToUtc(moment(this.state.dateRange[1]).format());
    // const timezone = this.state?.timezone?.id;
    const timePeriod = this.state.timePeriod?.id === 'All time' ? undefined : this.state.timePeriod?.id;
    return (
      <div className="h-100-minus-thin-header">
        <div className="row">
          <div className="col">
            <HeaderThin divider title={this.state.timePeriod?.name || 'All time'}>
              <div className="col col-5 col-md-4 col-lg-3 header-thin-children">
                <InputGroupBlock
                  name="timePeriod"
                  // labelText="Time Period"
                  className="no-margin-bottom float-right w-100"
                  inputGroupClassName="no-margin-bottom w-100"
                  placeholder="Time Period"
                  type="select"
                  options={timePeriods}
                  errors={this.state.errors.timePeriod}
                  value={this.state.timePeriod}
                  onChange={this.handleChangeTimePeriod}
                />
              </div>
            </HeaderThin>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <OverviewGraphs organisationId={this.props.organisations?.currentOrganisationId} competitionId={this.state.competitionId} cubejsApi={cubejsApi} timePeriod={timePeriod} />
            <TeamsGraphs organisationId={this.props.organisations?.currentOrganisationId} competitionId={this.state.competitionId} cubejsApi={cubejsApi} timePeriod={timePeriod} />
            <ForfeitsGraphs organisationId={this.props.organisations?.currentOrganisationId} competitionId={this.state.competitionId} cubejsApi={cubejsApi} timePeriod={timePeriod} />
          </div>
        </div>
      </div>
    );
  }
}
